import React, { useMemo } from "react";
import { Wrap, Title, List, Row, Name, Count } from "./CategorySidebarStyles";

export default function CategorySidebar({
  categories = [],
  activeId,
  onSelect,
}) {
  const items = useMemo(
    () => [
      { id: "__all__", name: "TOATE", count: null },
      ...(categories ?? []),
    ],
    [categories],
  );

  return (
    <Wrap>
      <Title>Categorii de produse</Title>

      <List>
        {items.map((c) => (
          <Row
            key={c.id ?? "all"}
            data-all={c.id === "__all__" ? "1" : "0"}
            $active={c.id === activeId}
            type="button"
            onClick={() => onSelect?.(c.id)}
          >
            <Name $active={c.id === activeId}>{c.name}</Name>
            {typeof c.count === "number" && <Count>({c.count})</Count>}
          </Row>
        ))}
      </List>
    </Wrap>
  );
}
